@if (isLoading) {
	<div class="overlay-new"></div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'insights.administration.users.title' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<!-- <mat-label>Filter</mat-label> -->
				<input [value]="searchText" matInput (keyup)="applyFilter($event)" [placeholder]="'insights.administration.users.search' | translate" [cdkTrapFocusAutoCapture]="showSearch" [cdkTrapFocus]="showSearch" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>

		<header-sub-menu [favoriteItems]="favoriteItems"></header-sub-menu>
	</div>
</div>

<!--
  <div style="display: flex; justify-content: right; margin-bottom: 10px; display: none">
    <mat-form-field style="height: 40px">
      <input
        matInput
        (keyup)="applyFilter($event)"
        [placeholder]="'insights.administration.users.search' | translate"
        #input />
      </mat-form-field>
      <button mat-icon-button>
        <mat-icon vgIcon="acies_search"></mat-icon>
      </button>
      <button mat-icon-button *ngIf="false">
        <mat-icon svgIcon="acies_delete"></mat-icon>
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="openUserAccess(null)"
        [disabled]="true">
        {{ 'insights.administration.users.newbtn' | translate
        }}<mat-icon svgIcon="acies_add" style="margin-left: 8px"></mat-icon>
      </button>
    </div>
    -->

<table class="table-responsive" mat-table recycleRows [dataSource]="dataSource" matSort>
	<ng-container matColumnDef="select">
		<th mat-header-cell *matHeaderCellDef>
			<mat-icon mat-list-icon class="account-select-icon" svgIcon="{{ isAllSelected ? 'acies_check' : 'acies_uncheck' }}" style="padding-top: 5px" (click)="selectOrClearAll()"></mat-icon>
		</th>
		<td mat-cell *matCellDef="let row">
			<mat-icon mat-list-icon class="account-select-icon" svgIcon="{{ selected.includes(row.id) ? 'acies_check' : 'acies_uncheck' }}" style="padding-top: 5px" (click)="select(row)"></mat-icon>
		</td>
	</ng-container>

	<ng-container matColumnDef="name">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.users.table.colname' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.name }}</td>
	</ng-container>

	<ng-container matColumnDef="email">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.users.table.colemail' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.email }}</td>
	</ng-container>

	<ng-container matColumnDef="grantType">
		<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">
			{{ 'insights.administration.users.table.colgranttype' | translate }}
		</th>
		<td mat-cell *matCellDef="let element" style="text-align: center">
			<mat-icon svgIcon="{{ element.grantType === 'managed' ? 'acies_true' : 'acies_false' }}" [ngClass]="element.grantType === 'managed' ? 'greenColor' : 'redColor'"></mat-icon>
		</td>
	</ng-container>

	<ng-container matColumnDef="adminuser">
		<th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">
			{{ 'insights.administration.users.table.coluseradm' | translate }}
		</th>
		<td mat-cell *matCellDef="let element" style="text-align: center">
			<mat-icon svgIcon="{{ element.adminuser === true ? 'acies_true' : 'acies_false' }}" [ngClass]="element.adminuser === true ? 'greenColor' : 'redColor'"></mat-icon>
		</td>
	</ng-container>

	<ng-container matColumnDef="reportmanager">
		<th mat-header-cell *matHeaderCellDef class="text-center" mat-sort-header>
			{{ 'insights.administration.users.table.colreportman' | translate }}
		</th>
		<td mat-cell *matCellDef="let element" style="text-align: center">
			<mat-icon svgIcon="{{ element.reportmanager === true ? 'acies_true' : 'acies_false' }}" [ngClass]="element.reportmanager === true ? 'greenColor' : 'redColor'"></mat-icon>
		</td>
	</ng-container>

	<ng-container matColumnDef="interval">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'insights.administration.users.table.colslideshow' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">{{ element.interval }}</td>
	</ng-container>

	<ng-container matColumnDef="menu">
		<th mat-header-cell *matHeaderCellDef style="text-align: end">
			@if (selected.length > 0) {
				<button disableRipple="true" mat-icon-button [matMenuTriggerFor]="menuMulti" aria-label="Multi select menu">
					<mat-icon mat-list-icon class="account-select-icon" svgIcon="acies_overflow_menu" style="padding-top: 5px; overflow: visible"></mat-icon>
				</button>
			}
			<mat-menu #menuMulti="matMenu">
				<button mat-menu-item (click)="sendInviteToken()">
					<span>{{ 'insights.administration.users.sendinvitebtn' | translate }}</span>
				</button>
			</mat-menu>
		</th>
		<td mat-cell *matCellDef="let row" style="text-align: end">
			<button disableRipple="true" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Edit user settings" (click)="selectSingle(row)">
				<mat-icon mat-list-icon class="account-select-icon" svgIcon="acies_overflow_menu" style="padding-top: 5px; overflow: visible"></mat-icon>
			</button>
			<mat-menu #menu="matMenu">
				<button mat-menu-item (click)="editAccess(row)">
					<span>{{ 'insights.administration.users.editaccessbtn' | translate }}</span>
				</button>
				<button mat-menu-item (click)="editUserReports(row)">
					<span>{{ 'insights.administration.users.editreportsbtn' | translate }}</span>
				</button>
				@if (canDeleteUser(row)) {
					<button mat-menu-item (click)="onDeleteUser(row)">
						<span>{{ 'insights.administration.users.deletebtn' | translate }}</span>
					</button>
				}
				@if (enableLoginAs(row)) {
					<button mat-menu-item (click)="loginAsUser(row)">
						<span>{{ 'insights.administration.users.loginasbtn' | translate }}</span>
					</button>
				}
			</mat-menu>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
<mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="20" showFirstLastButtons [length]="resultsLength"></mat-paginator>
